<div *ngIf="data" class="widget-container">
  <div class="header">
    {{ data.title }}
  </div>
  <div class="loading-content" *ngIf="!info || info.length == 0 || !info[0].values">
    <lib-loading></lib-loading>
  </div>
  <div *ngIf="info && info.length > 0 && info[0].values" class="scheduled-visits-container">
    <div class="scheduled-visits-content" (click)="iconAction()">
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 26.25V23.75H5V6.04377C5 5.43877 5.4325 4.92127 6.02625 4.81377L17.8663 2.66127C18.2738 2.58627 18.6637 2.85752 18.7375 3.26502C18.7463 3.30877 18.75 3.35252 18.75 3.39877V4.99877L23.75 5.00002C24.44 5.00002 25 5.56002 25 6.25002V23.75H27.5V26.25H22.5V7.50002H18.75V26.25H2.5ZM16.25 5.49502L7.5 7.08752V23.75H16.25V5.49502ZM15 13.75V16.25H12.5V13.75H15Z" fill="#EB194B"/>
      </svg>        
      <span class="scheduled-visits-counter">{{ (info[0].values.total < 10 && info[0].values.total != 0) ? '0' : '' }}{{ info[0].values.total }}</span>
      <span class="scheduled-visits-label">visita{{ (info[0].values.total > 1 || info[0].values.total == 0) ? 's' : '' }} agendada{{ (info[0].values.total > 1 || info[0].values.total == 0) ? 's' : '' }}</span>
    </div>
  </div>
</div>
